export default __webpack_public_path__ + "static/media/equitel-line.b78a9b9e.jpg";